<template>
  <el-form
    ref="registerForm"
    :model="registerForm"
    :rules="loginRules"
    class="login-form"
    auto-complete="on"
    label-position="left"
  >
    <div class="title-wrap">
      <img class="logo" alt="Kaopiz" :src="logo" />
      <h3 class="title">
        {{ "register.title" }}
      </h3>
    </div>
    <el-form-item prop="email">
      <span class="svg-container">
        <font-awesome-icon icon="user" />
      </span>
      <el-input
        v-model="registerForm.email"
        name="email"
        type="text"
        auto-complete="on"
        :placeholder="'login.email'"
      />
    </el-form-item>
    <el-form-item prop="full_name">
      <span class="svg-container">
        <font-awesome-icon icon="user" />
      </span>
      <el-input
        v-model="registerForm.full_name"
        name="full_name"
        type="text"
        auto-complete="on"
        :placeholder="'login.full_name'"
      />
    </el-form-item>
    <el-form-item prop="password">
      <span class="svg-container">
        <font-awesome-icon :icon="['fas', 'lock']" />
      </span>
      <el-input
        v-model="registerForm.password"
        name="password"
        auto-complete="on"
        placeholder="password"
        :type="pwdType"
        @keyup.enter.native="handleRegister"
      />
      <span class="show-pwd" @click="showPwd">
        <font-awesome-icon icon="eye" />
      </span>
    </el-form-item>
    <el-form-item>
      <el-button
        :loading="loading"
        type="primary"
        style="width: 100%"
        @click.native.prevent="handleRegister"
      >
        {{ "register" }}
      </el-button>
    </el-form-item>
    <div class="password-area">
      <div>
        <el-link type="primary"
          ><router-link :to="{ name: 'login' }"
            >Back to Login Page</router-link
          ></el-link
        >
      </div>
    </div>
  </el-form>
</template>

<script>
import loginMixin from "@/mixins/login.mixin";
import { mapActions } from "vuex";
export default {
  mixins: [loginMixin],
  data: function () {
    return {
      registerForm: {
        email: "",
        password: "",
        full_name: "",
      },
    };
  },
  methods: {
    showPwd() {
      if (this.pwdType === "password") {
        this.pwdType = "";
      } else {
        this.pwdType = "password";
      }
    },
    ...mapActions('auth', ['register']),
    async handleRegister() {
      let res = await this.register({
        sefl: this, data: this.registerForm
      });
      return res;
    },
  },
};
</script>

<style>
</style>